var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"_Mq-BpUfPN5xD2KPs0nA9"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

if (process.env.ENABLE_SENTRY) {
    Sentry.init({
        dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
        environment: process.env.NEXT_PUBLIC_STAGE,
        release: process.env.NEXT_PUBLIC_SENTRY_RELEASE,
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 1.0,
        // Session Replay is removed, not sampled down. It is a session recorder: it captures
        // rendered DOM, it initialises with the SDK rather than on consent, and it was recording
        // 10% of sessions plus every session that hit an error — including the underwriting
        // pages, before the visitor had answered the banner. Counsel's conditions for measuring
        // anything pre-consent name "no autocapture or session replay" explicitly.
        //
        // Masking is not a substitute: it hides text, but a highlighted option in a radio group
        // still shows which answer was chosen. Error and performance reporting are unaffected.
        //
        // The sample rates stay at 0 so that re-adding replayIntegration() does not silently
        // bring back 10% recording with it.
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,

        // Setting this option to true will print useful information to the console while you're setting up Sentry.
        debug: false,
    });
}
